import React, { useEffect, useRef, useState } from "react";
import "./css/organic-social-viewMore.css";
import { Line } from "react-chartjs-2";
import { getIconSrc, getImgSrc, getPlatformImg } from "../../../helpers/getImgSrc";
import { Notifications } from "../../../components/Notifications";
import DropdownFilter from "../../../partials/filter/DropdownFilter";
import { useNavigate, useParams } from "react-router-dom";
import DateRangePicker from "../../../partials/date-range-picker/DateRangePicker";
import gsap from "gsap";
import { handleApi } from "../../../utils/authentication";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import { getPlatformNameOrId } from "../../../helpers/getPlatformName";
import { getSvgIcons } from "../../../helpers/getReactIcons";

const SingleLineChart = ({ data, lineColor }) => {
  const options = {
    scales: {
      x: { display: false },
      y: { display: false },
    },
    plugins: {
      legend: { display: false },
    },
    elements: {
      point: { radius: 0 },
      line: { borderColor: lineColor },
    },
  };

  return <Line data={data} options={options} />;
};

const OrganicSocialViewMore = () => {

  const campaigns_view_more_ref = useRef()

  const [selectedDateRange, setSelectedDateRange] = useState({ value: null, label: "All Time" })
  const [customRange, setCustomRange] = useState({
    startDate: null,
    endDate: null
  })
  const [postImage, setPostImage] = useState('')

  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const [isLoading, setIsLoading] = useState(true)
  const [postData, setPostData] = useState({})
  const navigate = useNavigate()
  const [showFullDesc, setShowFullDesc] = useState(false)
  const [showFull, setShowFull] = useState(false);
  const { post_id, platform_id } = useParams(); // Extracting `id` from URL params

  const data = {
    labels: ["January", "February", "March", "April", "May"],
    datasets: [
      {
        label: "Reactions",
        data: [0, 59, 10, 81, 6],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
      {
        label: "Comments",
        data: [4, 39, 60, 7, 46],
        fill: false,
        backgroundColor: "#FFB1E0",
        borderColor: "#FFB1E0",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
      {
        label: "Shares",
        data: [35, 29, 0, 1, 36],
        fill: false,
        backgroundColor: "#95F3FA",
        borderColor: "#95F3FA",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
      {
        label: "Post Link Clicks",
        data: [25, 9, 40, 51, 26],
        fill: false,
        backgroundColor: "#FFE58A",
        borderColor: "#FFE58A",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
      {
        label: "Other Post Clicks",
        data: [15, 9, 30, 41, 16, 5, 0],
        fill: false,
        backgroundColor: "#8AABFF",
        borderColor: "#8AABFF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        display: true,
        ticks: {
          display: false,
          stepSize: 15, // Set y-axis ticks with a 50 points gap
        },
        grid: {
          drawBorder: false,

          borderDash: [5, 5], // Ensure y-axis grid line is dashed
        },
      },
      x: {
        display: true,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 30,
          boxHeight: 10,
          padding: 20,
          usePointStyle: true,
          pointStyle: "rectRounded",
          color: "#908DAD", // Set legend text color
        },
      },
      tooltip: {
        mode: "index", // Show tooltip for the entire column
        intersect: false,
      },
    },
    layout: {
      padding: {
        top: 20,
      },
    },
  };

  const reactionsData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 59, 10, 81],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const leadsData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 9, 10, 81],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const clicksData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 1, 6, 0],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const applicationsData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 5, 60, 51, 0],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const handleDateRangeSelect = (selectedOption) => {
    if (selectedOption.value == "Custom Range") {
      setShowDateRangePicker(true)

    } else {
      setSelectedDateRange(selectedOption)
    }
  };
  useEffect(() => {
    if (customRange?.startDate || customRange?.endDate) {
      setSelectedDateRange({
        value: "Custom Range",
        label: "Custom Range"
      })
    }
  }, [customRange?.startDate, customRange?.endDate]);


  useEffect(() => {
    gsap.from(campaigns_view_more_ref.current, {
      y: 500,
      duration: 1,
      opacity: 0,
      ease: "easeIn",
      onComplete: () => {
        if (campaigns_view_more_ref.current && campaigns_view_more_ref.current.style.transform)
          campaigns_view_more_ref.current.style.transform = "";
      },
    });

  }, []);

  //getting campaign details
  const getPostDetails = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("post_id", post_id);
      formData.append("platform_id", platform_id);
      formData.append("days", selectedDateRange?.value);
      formData.append("start_date", customRange?.startDate);
      formData.append("end_date", customRange?.endDate);

      let result = await handleApi("get_post_details", method, headers, formData);
      if (result?.success) {
        setPostData(result?.data[0])

        setPostImage(result?.data[0]?.page_data?.image_url)

      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to get Ad details"
        );
      }
    } catch (e) {
      toast.error(e.message ? e.message : "Failed to get Ad details");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPostDetails()
  }, [selectedDateRange]);




  const description = postData?.page_data?.description ?? '----';
  const words = description.trim().split(/\s+/);
  const isLong = words.length > 70;

  const shortText = words.slice(0, 70).join(' ') + (isLong ? '...' : '');








  return (
    <>
      {isLoading ? <LoadingSpinner /> :
        <div ref={campaigns_view_more_ref}>
          <div className="campaigns-view-more-header">
            <div className="campaigns-view-more-header-top-section d-flex justify-content-between align-items-center flex-wrap">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/client/organic-social");
                  }}
                  className="d-flex align-items-center"
                >
                  <img className="" src={getIconSrc("arrow", "svg")}></img>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <div style={{ width: '1.5rem', height: '1.5rem' }}>
                    <img src={getPlatformImg(platform_id)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>

                  <span className="campaigns-view-more-page-title">
                    {getPlatformNameOrId(platform_id)}
                  </span>
                  <span
                    className="ms-2 "
                    style={{
                      color: "gray",
                      fontSize: "14px",
                      fontFamily: "aeonik_medium",
                    }}
                  >

                  </span>
                </div>


              </div>
              <div className="d-flex align-items-center gap-3">
                <DropdownFilter
                  styling={{ backgroundColor: "transparent" }}
                  label={"Date"}
                  onSelect={handleDateRangeSelect}
                  options={[
                    { value: null, label: "All Time" },
                    { value: "30 Days", label: "30 Days" },
                    { value: "90 Days", label: "90 Days" },
                    { value: "180 Days", label: "180 Days" },
                    { value: "Custom Range", label: "Custom Range" },
                  ]}
                  selectedOption={{
                    value: selectedDateRange.value,
                    label: selectedDateRange.label,
                  }}
                />
                <Notifications />
                <div style={{ cursor: "pointer" }}>
                  <img className="" src={getIconSrc("export", "svg")}></img>
                </div>
              </div>
            </div>
            <div className="campaigns-view-more-header-content row m-0 ">
              {/* <div className="col-md-3 row m-0 d-flex align-items-center">
                <div className="col-md-5">
                  <div className="header-content-label">REACTIONS</div>
                  <div className="header-content-value">852</div>
                </div>
                <div className="col-md-7">
                  <SingleLineChart data={reactionsData} lineColor="#D3A4FF" />
                </div>
              </div>
              <div className="col-md-3 row m-0 d-flex align-items-center">
                <div className="col-md-5">
                  <div className="header-content-label">CLICKS</div>
                  <div className="header-content-value">852</div>

                </div>
                <div className="col-md-7">
                  <SingleLineChart data={clicksData} lineColor="#FFB1E0" />
                </div>
              </div>
              <div className="col-md-3 row m-0 d-flex align-items-center">
                <div className="col-md-5">
                  <div className="header-content-label">LEADS</div>
                  <div className="header-content-value">852</div>

                </div>
                <div className="col-md-7">
                  <SingleLineChart data={leadsData} lineColor="#95F3FA" />
                </div>
              </div>
              <div className="col-md-3 row m-0 d-flex align-items-center">
                <div className="col-md-5">
                  <div className="header-content-label">APPLICATIONS</div>
                  <div className="header-content-value">852</div>

                </div>
                <div className="col-md-7">
                  <SingleLineChart data={applicationsData} lineColor="#FFE58A" />
                </div>
              </div> */}


              {/* {postData?.header_metrics_data?.map((metrics_data)=>{

                return <div key={metrics_data?.name} className="col-md-3 row m-0 d-flex align-items-center">
                <div className="col-md-5">
                  <div className="header-content-label">{metrics_data?.name}</div>
                  <div className="header-content-value">{metrics_data?.value}</div>

                </div>
                <div className="col-md-7">
                  <SingleLineChart data={applicationsData} lineColor="#FFE58A" />
                </div>
              </div>
              })} */}
              <div>
                {postData?.is_pre_business_account ? <div class="alert alert-danger" role="alert">
                 This post was created before the account was converted to a business account. As per platform policy, insights and metrics are only available for posts published after the conversion, so data for earlier posts is not accessible.
                </div> : <></>}
              </div>

              {/* page data and discription */}
              <div className="d-flex align-items-start ">
                <div className="w-75">
                  <h2>{postData?.page_data?.title ?? '----'}</h2>
                  {/* <p> {postData?.page_data?.description ?? '----'}</p> */}
                  <p>
                    {showFull || !isLong ? description : shortText}
                    {isLong ? (
                      <button
                        onClick={() => setShowFull(prev => !prev)}
                        style={{
                          marginLeft: '8px',
                          background: 'none',
                          border: 'none',
                          color: 'var(--primary-color)',
                          cursor: 'pointer',
                          padding: 0
                        }}
                      >
                        {showFull ? 'Show less' : 'Read more'}
                      </button>
                    ) : ''}
                  </p>
                </div>
                <div className="w-25 mt-4 gap-5 p-2">
                  <div className="row">
                    <div className="col-4">
                      <div className="d-flex gap-2 align-items-center">
                        <p className="mb-0">{getSvgIcons('clock', { color: 'var( --tertiary-color)' })}</p>
                        <p className="mb-0">Linked At</p>
                      </div>

                    </div>
                    <div className="col-8">
                      <p className="mb-0">{postData?.page_data?.created_at ?? ''}</p>
                    </div>

                  </div>
                  <div className="row">
                    <div className="col-4">

                      <div className="d-flex gap-2 align-items-center">
                        <p className="mb-0">{getSvgIcons('clock', { color: 'var( --tertiary-color)' })}</p>
                        <p className="mb-0"> Last Synced</p>
                      </div>

                    </div>
                    <div className="col-8">
                      <p className="mb-0">{postData?.page_data?.last_synced ?? ''}</p>
                    </div>

                  </div>
                  <div className="row">
                    <div className="col-4">
                      <div className="d-flex gap-2 align-items-center">
                        <p className="mb-0">{getSvgIcons('source', { color: 'var( --tertiary-color)' })}</p>
                        <p className="mb-0"> Source</p>
                      </div>
                    </div>
                    <div className="col-8 position-relative">
                      <div className="d-flex flex-wrap">
                        <a
                          href={postData?.page_data?.post_url}
                          className="text-truncate d-inline-block w-100"
                          style={{ maxWidth: '100%', overflowWrap: 'break-word' }}
                          target="_blank"
                          rel="noopener noreferrer"
                          data-bs-toggle="tooltip" 
                          title={postData?.page_data?.post_url}


                        >
                          {postData?.page_data?.post_url ?? ''}
                        </a>
                      </div>


                    </div>

                  </div>
                </div>

              </div>




            </div>
            <div className="campaigns-view-more-body">
              <div className="campaigns-view-more-card">
                <div className="campaigns-view-more-card-header d-flex justify-content-between flex-wrap gap-2 ">
                  { /* <div className="d-flex flex-column gap-2">
                    <div className="chart-label">REACTIONS</div>
                    <div className="chart-value">0</div>
                  </div>
                  <div className="d-flex flex-column gap-2">
                    <div className="chart-label">COMMENTS</div>
                    <div className="chart-value">0</div>
                  </div>
                  <div className="d-flex flex-column gap-2">
                    <div className="chart-label">SHARES</div>
                    <div className="chart-value">0</div>
                  </div>
                  <div className="d-flex flex-column gap-2">
                    <div className="chart-label">POST LINK CLICKS</div>
                    <div className="chart-value">0</div>
                  </div>
                  <div className="d-flex flex-column gap-2">
                    <div className="chart-label">OTHER POST CLICKS</div>
                    <div className="chart-value">0</div>
                  </div> */}
                </div>
                <div className="campaigns-view-more-card-body">

                  {/* line graph  */}
                  {/* <Line data={data} options={options} /> */}
                  <div className="organic_post_metrics_container">
                    <div className="organic_post_metrics_image_container">

                      {postData?.page_data?.media_type?.toLowerCase()==="video" ? 
                      <video src={postData?.page_data?.media_url} alt="" 
                    
                      autoPlay
                      muted
                      playsInline
                      style={{width:'100%',height:'100%'}}
                      controls
                      
                      /> : 
                      
                      <img src={postImage ? postImage : getImgSrc("no_image_found", "png")} alt=""
                        onError={() => {
                          setPostImage('')
                        }}
                      />
                      
                      }

                      {/* <img src={postImage ? postImage : getImgSrc("no_image_found", "png")} alt=""
                        onError={() => {
                          setPostImage('')
                        }}

                      /> */}

                    </div>
                    <div className="organic_post_metrics_content_container">
                      <div className="metrics_card_container">
                        {postData?.header_metrics_data?.map((metrics_data) => {
                          return <div className="post_metrics_card" key={metrics_data?.name}>
                            <div className="d-flex align-items-start gap-2">
                              <span className=""> {metrics_data?.name}</span>
                              <span className="" style={{ cursor: 'pointer' }} data-bs-toggle="tooltip" data-bs-placement="left" title={metrics_data?.description}>{getSvgIcons('info', {})}</span>
                            </div>

                            <p className=""> {Number(String(metrics_data?.value).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>

                          </div>
                        })
                        }

                      </div>
                      <div className="other_metrics_card">
                        <div className="heading">
                          <p>Other Metrics</p>
                        </div>
                        <div className="other_metrics_card_container">
                          {postData?.page_data?.other_metrics?.length > 0 && postData?.page_data?.other_metrics.map((metrics_data) => {
                            return <div key={metrics_data?.name}>
                              <div className="d-flex gap-3 align-items-start">
                                <span>{metrics_data?.name}</span>
                                {/* <span style={{fontSize:'0.2rem !important'}}>{metrics_data?.description ?? ''}</span> */}
                                <span className="" style={{ cursor: 'pointer' }} data-bs-toggle="tooltip" data-bs-placement="left" title={metrics_data?.description}>{getSvgIcons('info', {})}</span>
                              </div>

                              <span> {Number(String(metrics_data?.value).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</span>
                            </div>
                          })}




                        </div>

                      </div>


                    </div>


                  </div>




                </div>
              </div>
            </div>
          </div>
          <DateRangePicker
            showDateRangePicker={showDateRangePicker}
            setShowDateRangePicker={setShowDateRangePicker}
            dateRange={customRange}
            setDateRange={setCustomRange}
          />
        </div>}
    </>
  );
};

export default OrganicSocialViewMore;
